import type { PostgrestError } from '@supabase/supabase-js';

import { supabase } from './supabase';

/**
 * Typed wrapper around `supabase.rpc()`.
 *
 * Until `npm run db:types` can run against a live database, supabase-js has no schema
 * to infer from and `rpc()` resolves to `any`. Keeping the one necessary cast here
 * means call sites stay type-safe and there is a single place to delete once
 * `src/types/database.ts` is generated.
 *
 * Errors are thrown rather than returned, so TanStack Query mutations surface them.
 */
export async function rpc<T = void>(fn: string, args: Record<string, unknown> = {}): Promise<T> {
  const { data, error } = (await supabase.rpc(fn, args)) as {
    data: T;
    error: PostgrestError | null;
  };

  if (error) throw error;
  return data;
}
